if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        // The quick add modal reuses the product markup; the bar only belongs on the full product page.
        if (this.closest('quick-add-modal')) return;

        const productButton = this.getProductButton();
        if (!productButton) return;

        this.hidden = false;
        this.stickyButton = this.querySelector('.sticky-atc__button');
        this.stickyButton.addEventListener('click', this.onClick.bind(this));

        this.observer = new IntersectionObserver(([entry]) => {
          const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (visible) this.sync();
          this.classList.toggle('is-visible', visible);
        });
        this.observer.observe(productButton);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      getProductButton() {
        return document.getElementById(this.dataset.buttonId);
      }

      sync() {
        const productButton = this.getProductButton();
        if (!productButton) return;

        this.stickyButton.textContent = productButton.querySelector('span')?.textContent.trim() || '';
        this.stickyButton.toggleAttribute('aria-disabled', productButton.disabled);

        const price = document.getElementById(this.dataset.priceId);
        const priceTarget = this.querySelector('.sticky-atc__price');
        if (!price || !priceTarget) return;
        const currentPrice = price.querySelector('.price--on-sale')
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item--regular');
        if (currentPrice) priceTarget.textContent = currentPrice.textContent.trim();
      }

      onClick() {
        const productButton = this.getProductButton();
        if (!productButton) return;

        if (productButton.disabled) {
          productButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        productButton.click();
      }
    }
  );
}
